(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-all-products-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  let active;
  let preview;
  function hide() {
    active = null;
    if (preview) preview.hidden = true;
  }
  function show(link) {
    if (!link || !window.matchMedia('(min-width: 992px) and (hover: hover)').matches) return;
    if (active === link) return;
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'home-menu-product-preview';
      preview.setAttribute('aria-hidden', 'true');
      preview.appendChild(document.createElement('img'));
      document.body.appendChild(preview);
    }
    active = link;
    preview.hidden = true;
    const image = preview.firstElementChild;
    image.onload = () => {
      if (active !== link) return;
      const bounds = link.getBoundingClientRect();
      const panel = link.closest('.all-products-panel').getBoundingClientRect();
      const width = Math.min(280, panel.width - 16);
      const height = Math.min(230, panel.bottom - bounds.bottom - 16, window.innerHeight - bounds.bottom - 16);
      if (height < 60) return;
      Object.assign(preview.style, {
        left: `${Math.max(panel.left + 8, Math.min(bounds.left, panel.right - width - 8))}px`,
        top: `${bounds.bottom + 6}px`, width: `${width}px`, height: `${height}px`, boxSizing: 'border-box'
      });
      preview.hidden = false;
    };
    image.onerror = hide;
    image.alt = link.dataset.menuPreviewAlt;
    image.src = link.dataset.menuPreview;
    if (image.complete && image.naturalWidth) image.onload();
  }
  document.addEventListener('pointerover', event => show(event.target.closest('[data-menu-preview]')));
  document.addEventListener('pointerout', event => {
    if (active && active.contains(event.target) && !active.contains(event.relatedTarget)) hide();
  });
  document.addEventListener('focusin', event => show(event.target.closest('[data-menu-preview]')));
  document.addEventListener('focusout', event => { if (active === event.target) hide(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  document.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);
})();
  } catch(e) { console.error(e); }
})();

})();
